<template>
 <div class="home"> 
	<search></search>
	<!-- <toplink></toplink>	 -->
	<swiper></swiper>
	<!-- <userHeader></userHeader> -->
	<menus></menus>
	<devicecard host="Home"></devicecard>
	<QuickLink></QuickLink>
	<!-- <hot></hot> -->
	<div class="listTitle">
    <div class="item1">
      <van-icon name="question" color="red" size="bigger"/>
      使用问答</div>
    <div class="item2" @click="gotoQA()">更多...</div>  
  	</div>
	<QAList host="Home" sn="" models=""></QAList>
	<!-- <appdownload></appdownload> -->
	
 </div>
</template>
<script>
// @ is an alias to /src
import swiper from "../components/swiper.vue"
import menus from '../components/menus.vue'
import appdownload from '../components/appdownload.vue'
import hot from '../components/hot.vue'
import userHeader from '../components/userheader.vue'
import toplink from '../components/toplink.vue'
import QAList from "../components/qalist.vue"
import search from "../components/serach.vue"
import devicecard  from "../components/devicecard.vue"
import QuickLink from "../components/quickLink.vue"
import global  from "../components/global.vue"
// import Vue from 'vue'

export default {
  name: 'Home',
  components: {
	  search,
	  toplink,
	  swiper,
	  menus,
	  appdownload,
	  hot,
	  userHeader,
	  QAList,
	  devicecard,
	  QuickLink
  },
  data(){
  		return{			
  		   notes: "",
		   notice:"",
		   currentModel:"",
		   sns:''
  		}  	 
	},
	mounted(){		
		document.title ='至像服务';	
	},
	created(){    
		
		   this.currentModel = "识别机型：" + this.$route.query.id;
		   console.log(this.$route.query.sn,'querySN')	

		   if (this.$route.query.sn !='undefined')
		   {
			localStorage['sn'] = this.$route.query.sn;
			global.currentSN = this.$route.query.sn;
		   }
		   if (this.$route.query.id !='undefined')
		   {
			localStorage['model'] = this.$route.query.id;
			global.currentModel = this.$route.query.id;
		   }

		   console.log(localStorage['sn'],'queryStorage')	
		   
	},
	methods:{
        gotoQA(){
          this.$router.push({ path:'/qa?sn=' + localStorage['sn'] })		
        }		 
	}
  }

</script>
<style>
  .home {
    margin: 0 auto;
	padding: 0 auto;
	height: 100vh;
	width: 100vw;
	max-width: 100%;
	overflow-y: none;

  } 
  .modelbox {
	width:100%;
	text-align:center;
  }
  
.listTitle{
  padding:20px;
  display: flex;
  flex-direction: row;
  align-items: stretch;

  .item {
    flex: 1;
    padding: 10px;
  }

  .item1 {
    padding:10px;
    background-color: #f6f6f6;
    width: 50%;
    text-align: left;
  }

  .item2 {
    padding:10px;
    background-color: #f6f6f6;
    width: 50%;
    text-align: right;
  }

}
</style>
